import { render, staticRenderFns } from "./UiSingleErrorExtractor.vue?vue&type=template&id=1be448fe&scoped=true&"
import script from "./UiSingleErrorExtractor.vue?vue&type=script&lang=js&"
export * from "./UiSingleErrorExtractor.vue?vue&type=script&lang=js&"
import style0 from "./UiSingleErrorExtractor.vue?vue&type=style&index=0&id=1be448fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be448fe",
  null
  
)

export default component.exports